// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1pmVv","header":"ReportDetails_header__2Pgks","title":"ReportDetails_title__2H35B","left":"ReportDetails_left__3nRiP"};